import styled from 'styled-components'
import { color, size } from 'ui/themes/utils'

import ReactInputPosition from 'react-input-position'

export const ImageMagnify = styled(ReactInputPosition)`
  &&& {
    position: relative;
    overflow: hidden;

    display: flex;
    justify-content: center;
    align-items: center;

    z-index: 10;
    background-color: ${color('white')};
  }
`

export const ImageContainer = styled.div`
  &&& {
    display: inline-block;

    padding: 2px;
    padding-bottom: 0;

    border: ${size('borderWidth')} solid ${color('Misc/Divider')};

    z-index: 10;
    background-color: ${color('white')};
  }
`

export const Image = styled.img`
  &&& {
    margin-bottom: -2px;
  }
`

export const Portal = styled.div`
  &&& {
    width: 100%;
    height: 100%;

    position: relative;
    overflow: hidden;

    background-image: url(${({ image }) => image});
    background-repeat: no-repeat;
    background-size: cover;

    z-index: 1024;

    transform: ${({ scale }) => `scale(${scale})`};
  }
`

export const PortalContainer = styled.div`
  width: ${({ width }) => width}px;
  height: ${({ height }) => height}px;

  overflow: hidden;
`

export const MagnifyContainer = styled.div`
  position: absolute;
  top: 30px;
  left: 310px;

  background-color: ${color('white')};
  box-shadow: ${size('shadow', 'md')};
`
